import React, { useState } from 'react';
import { changePassword } from './DataHandler';
import './ChangePasswordModal.css';

interface ChangePasswordModalProps {
    onClose: () => void;
}

const ChangePasswordModal: React.FC<ChangePasswordModalProps> = ({ onClose }) => {
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState<string | null>(null);
    const [isError, setIsError] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setMessage(null);
        setIsError(false);

        if (newPassword.length < 4) {
            setMessage('비밀번호는 최소 4자 이상이어야 합니다.');
            setIsError(true);
            return;
        }

        if (newPassword !== confirmPassword) {
            setMessage('비밀번호가 일치하지 않습니다.');
            setIsError(true);
            return;
        }

        try {
            const response = await changePassword(newPassword);
            setMessage(response.message || '비밀번호가 성공적으로 변경되었습니다.');
            setIsError(false);
            setTimeout(() => {
                onClose();
            }, 1500);
        } catch (error: any) {
            setMessage(error.message || '비밀번호 변경 중 오류가 발생했습니다.');
            setIsError(true);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h3>비밀번호 변경</h3>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>새 비밀번호</label>
                        <input
                            type="password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            placeholder="새 비밀번호 입력"
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>비밀번호 확인</label>
                        <input
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            placeholder="비밀번호 다시 입력"
                            required
                        />
                    </div>
                    {message && (
                        <p className={`message ${isError ? 'error' : 'success'}`}>
                            {message}
                        </p>
                    )}
                    <div className="modal-actions">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>
                            취소
                        </button>
                        <button type="submit" className="btn btn-primary">
                            변경하기
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ChangePasswordModal;
